/*
 * @Author: zhaihaooran
 * @Date: 2021-08-10 13:54:39
 * @LastEditors: junchao
 * @FilePath: /umu_mobile/src/learningMap/common/components/loading/loading.tsx
 */
/**
 * @description logo
 * @author duanjun
 * @date
 */

import React from 'react';

import './loading.scss';

interface IProps {
    show?: boolean;
    className?: string;
}

export default function Loading({ show = true, className = '' }: IProps) {
    if (!show) {
        return null;
    }
    return (
        <div className={`page-loading ${className}`}>
            <div className="sprite-frame"></div>
        </div>
    );
}
